import BaseModel from 'src/model/base.model';
import DiagramModel from 'src/model/diagram.model';
import ProductModel from 'src/model/product.model';

class ModelModel extends BaseModel {
  constructor() {
    super();
    this.id = -1;
    this.modelID = -1;
    this.diagrams = [];
    this.modelNumber = -1;
    this.modelName = -1;
    this.manufacturer = '';
    this.brandName = '';
    this.applianceType = '';
    this.productionNumber = '';
  }

  public id: number;
  public modelID: number;
  public diagrams: DiagramModel[];
  public commonParts: DiagramModel[];
  public modelNumber: number;
  public modelName: number;
  public manufacturer: string;
  public brandName: string;
  public applianceType: string;
  public productionNumber: string;
}

export default ModelModel;
